module.exports = __webpack_public_path__ + "static/media/creditCard.011affa3.png";